import React from "react";
import ReactEcharts from "echarts-for-react";
import getChartColorsArray from "../../../components/Common/ChartsDynamicColor";
import moment from "moment";
import "moment/locale/tr"; // bu gerekli

const LineChartByDay = ({ dataColors, polls }) => {
  const lineEChartColors = getChartColorsArray(dataColors);

  // 1. Günlük gruplama
  const dailyCounts = {};

  polls.forEach(poll => {
    const day = moment(poll.Created_DateTime).format("DD-MM-YYYY"); // örn: "01-01-2025"
    dailyCounts[day] = (dailyCounts[day] || 0) + 1;
  });

  // 2. Tarihleri sıraya sok
  const sortedDates = Object.keys(dailyCounts).sort((a, b) =>
    moment(a, "DD-MM-YYYY").diff(moment(b, "DD-MM-YYYY"))
  );

  // 3. X ekseni ve Y ekseni verileri
  const xAxisData = sortedDates;
  const seriesData = sortedDates.map(date => dailyCounts[date]);

  // 4. Grafik ayarları
  const options = {
    tooltip: { trigger: "axis" },
    grid: { zlevel: 0, x: 50, x2: 50, y: 30, y2: 30, borderWidth: 0 },
  xAxis: {
  type: "category",
  data: xAxisData,
  axisLabel: {
    fontSize: 12,
    formatter: function (value) {
      return value; // Gerekirse burayı da özelleştirebiliriz
    },
  },
  axisLine: {
    lineStyle: {
      color: "#8791af"
    },
  },
},
  yAxis: {
  type: "value",
  minInterval: 1, // her aralık en az 1 olsun
  interval: 1,    // aralıklar tam sayı olsun
  axisLabel: {
    formatter: '{value}', // 1, 2, 3 şeklinde yazdır
  },
  axisLine: {
    lineStyle: {
      color: "#8791af"
    },
  },
  splitLine: {
    lineStyle: {
      color: "rgba(166, 176, 207, 0.1)"
    }
  }
},
    series: [
      {
        data: seriesData,
        type: "line",
        smooth: true,
      },
    ],
    color: lineEChartColors,
    textStyle: { color: ["#8791af"] },
  };

  return (
    <div id="line-chart" className="e-chart">
      <ReactEcharts style={{ height: "400px" }} option={options} />
    </div>
  );
};

export default LineChartByDay;
